module.exports = __webpack_public_path__ + "img/1m.bceea098.png";